import firebaseConfig from "./firebaseConfig";
import { getAuth } from "firebase/auth";
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics, isSupported, setAnalyticsCollectionEnabled } from "firebase/analytics";

let app;
let db;
let auth;
let storage;
let analyticsPromise = Promise.resolve(null);

if (typeof window !== "undefined") {
	if (!getApps().length) {
		app = initializeApp(firebaseConfig);
	} else {
		app = getApp();
	}
	db = getFirestore(app);
	storage = getStorage(app);
	auth = getAuth(app);

	analyticsPromise = isSupported().then(yes => yes ? getAnalytics(app) : null);
}

export async function configureAnalyticsForUser(email) {
	const analytics = await analyticsPromise;
	if (!analytics) return;
	const isInternal = typeof email === 'string' && email.endsWith('@alwarqasurvey.com');
	setAnalyticsCollectionEnabled(analytics, !isInternal);
}

export { auth, db, storage };
